import { createContext } from "react";

export const CreditUserContext = createContext();

